// extracted by mini-css-extract-plugin
export default {"default":"Avatar_default__gwRiO"};